class BanicScrollIndicator {
  constructor() {
    this.root = document.documentElement;
    this.frame = 0;
    this.hideTimer = 0;
    this.indicator = document.createElement('div');
    this.indicator.className = 'banic-scroll-indicator';
    this.indicator.setAttribute('aria-hidden', 'true');

    this.thumb = document.createElement('span');
    this.thumb.className = 'banic-scroll-indicator__thumb';
    this.indicator.appendChild(this.thumb);
    document.body.appendChild(this.indicator);

    this.onScroll = this.onScroll.bind(this);
    this.queueUpdate = this.queueUpdate.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.queueUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.queueUpdate);
      this.resizeObserver.observe(document.documentElement);
      this.resizeObserver.observe(document.body);
    }

    this.update();
  }

  queueUpdate() {
    if (this.frame) return;

    this.frame = window.requestAnimationFrame(() => {
      this.frame = 0;
      this.update();
    });
  }

  onScroll() {
    this.root.classList.add('banic-scroll-active');
    this.queueUpdate();
    window.clearTimeout(this.hideTimer);
    this.hideTimer = window.setTimeout(() => {
      this.root.classList.remove('banic-scroll-active');
    }, 650);
  }

  update() {
    const viewportHeight = window.innerHeight;
    const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    const scrollRange = documentHeight - viewportHeight;

    if (scrollRange <= 1) {
      this.indicator.hidden = true;
      this.root.classList.remove('banic-scroll-active');
      return;
    }

    this.indicator.hidden = false;

    const trackHeight = Math.max(0, viewportHeight - 4);
    const proportionalHeight = trackHeight * (viewportHeight / documentHeight);
    const thumbHeight = Math.min(96, Math.max(36, proportionalHeight));
    const scrollProgress = Math.min(1, Math.max(0, window.scrollY / scrollRange));
    const thumbPosition = scrollProgress * Math.max(0, trackHeight - thumbHeight);

    this.root.style.setProperty('--banic-scroll-indicator-height', `${thumbHeight.toFixed(2)}px`);
    this.root.style.setProperty('--banic-scroll-indicator-y', `${thumbPosition.toFixed(2)}px`);
  }
}

if (
  document.documentElement.classList.contains('banic-overlay-scrollbar') &&
  !(window.Shopify && window.Shopify.designMode)
) {
  new BanicScrollIndicator();
}
